import React, { Component, forwardRef } from 'react';
import { BrowserRouter, useLocation, useNavigate, useParams, useInRouterContext } from 'react-router-dom';
import { selectedCountryDetails } from 'utils/phoneInput';
import { Iterable } from 'immutable';

export const toJS = (WrappedComponent) => {
  const ToJS = (wrappedComponentProps) => {
    const KEY = 0;
    const VALUE = 1;

    const propsJS = Object.entries(wrappedComponentProps).reduce((newProps, wrappedComponentProp) => {
      const newNewProps = newProps;
      newNewProps[wrappedComponentProp[KEY]] = Iterable.isIterable(wrappedComponentProp[VALUE])
        ? wrappedComponentProp[VALUE].toJS()
        : wrappedComponentProp[VALUE];
      return newNewProps;
    }, {});

    return <WrappedComponent {...propsJS} />;
  };

  ToJS.displayName = `ToJS(${WrappedComponent.displayName || WrappedComponent.name || 'Component'})`;

  return ToJS;
};

export const withForwardedRef = (WrappedComponent) =>
  forwardRef((props, ref) => <WrappedComponent {...props} forwardedRef={ref} />);

export class OnUpdateWrapper extends Component {
  componentDidUpdate(prevProps) {
    if (prevProps.pathname !== this.props.pathname) {
      this.props.onUpdate();
      selectedCountryDetails.remove();
    }
  }

  render() {
    return this.props.children;
  }
}

/**
 * Injects router-related props (location, navigate, params) into the component.
 * Mimics legacy withRouter behavior from React Router v5 for compatibility.
 */
export const injectRouterProps = (WrappedComponent) =>
  function RouterPropsWrapper(props) {
    const location = useLocation();
    const navigate = useNavigate();
    const params = useParams();

    return <WrappedComponent {...props} match={{ params }} router={{ location, navigate, params }} />;
  };

/**
 * Conditionally wraps a component with <BrowserRouter> only if it's not already inside a router.
 */
export const withRouter = (ComponentContainer) => {
  const ComponentWithRouterProps = injectRouterProps(ComponentContainer);

  return (props) => {
    const isInRouter = useInRouterContext();

    if (isInRouter) {
      return <ComponentWithRouterProps {...props} />;
    }

    return (
      <BrowserRouter>
        <ComponentWithRouterProps {...props} />
      </BrowserRouter>
    );
  };
};
